import { useFetch } from "../../hooks/useFetch"
import LoadSimple from "../LoadSimple"
import Modal from 'react-modal';
import ModalDeleteBuzon from "./ModalDeleteBuzon";
import { useState,useEffect } from 'react';
import { capitalizeFirstLetter } from "../../utils/utils";
import { lang } from "../generales/traduction";
const deleteBuzonModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      background: '#ffffff !important',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width:'60%',
      height:'60%',
      padding:'20px'
    },
  };
  /* estilos modal crear relacion */
const BuzonAfectaModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width:'40%',
    height:'70%',
    padding:'20px'
  },
};
const BuzonList =({buscar_Buzon, startLimit,handleShowPopup,pageActual,limitList,languaje,mode,devices,editActive,dataBuzon,setDataBuzon,handleChangEdit,setData,setRegisterIsValid ,setLoading,setError,server,dataUsers,setDataUsers,searchResults, setSearchResults,searchTerm,Buzonelected,setBuzonelected})=>{
  // const dataUsers=useFetch('cassia/ci','',localStorage.getItem('access_token'),'GET',server)

  const [deleteBuzonModalOpen, setdeleteBuzonModalOpen] =useState(false);
  const [CreateBuzonModalOpen, setCreateBuzonModalOpen] =useState(false);
  const [userSelected,setUserSelected]=useState({})
  const [BuzonAfectaModalOpen, setBuzonAfectaModalOpen] =useState(false);
  const [BuzonelectedAux,setBuzonelectedAux]=useState([])
  const [auth,setAuth]=useState(false)
  var dataList=(searchTerm==='')?dataUsers.data:searchResults;
  const crear = () => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setCreateBuzonModalOpen(true)
  }
  function closCreateBuzonModal() {
    // setEditActive(true)
    setCreateBuzonModalOpen(false);
  }
  function openDeleteUserModal() {
      setdeleteBuzonModalOpen(true);
    }

  function closDeleteBuzonModal() {
    setdeleteBuzonModalOpen(false);
  }
  const handleActionResponse = (data,a) => {
    setAuth(a)
    openDeleteUserModal()
    setUserSelected(data)
    // Realiza las acciones deseadas al hacer clic en el marcador
  };
  useEffect(()=>{
     buscar_Buzon() 
  },[])

  const BuzonelectRow=(elemento)=>{
    setBuzonelected(elemento)
  }
  function closeBuzonAfectaModal() {
  
    setBuzonAfectaModalOpen(false);
    
  }

  const openBuzonAfectaModal=(elemento) =>{
    setBuzonelectedAux(elemento)
    setBuzonAfectaModalOpen(true);
  }
  const extractComent=(texto)=>{
    const match = texto.match(/Comentario:\s*(.*)/);
    const comentario = match ? match[1].trim() : '';
    return comentario;
  }
  return(
      <>
      <div className='cont-row-user-list'>
      {(dataUsers.loading ) ?<div className='cont-load-user-list'><LoadSimple></LoadSimple></div>:
        
         
        dataList.slice(startLimit, parseInt(pageActual) * parseInt(limitList)).map((elemento, indice) => (
          <div className={"row-table-portafolio"+mode} key={indice}   onClick={()=>{}}>
            <div className='field-body-table-Buzon field-small'>
              {elemento.id}
            </div>
            
            <div className='field-body-table-Buzon field-larger'style={{width:'25%'}} >
              {elemento.requester_user}
            </div>
            <div className='field-body-table-Buzon field-larger'style={{width:'25%'}} >
              {elemento.created_at.replace('T',' ')}
            </div>
            <div className='field-body-table-Buzon field-larger'>
              {elemento.status}
            </div>
           
           
            <div className='field-body-table-Buzon field-larger' style={{width:'40%'}}>
              {extractComent(elemento.comment_history)}
            </div>
           
            {/* <div className='field-body-table-Buzon field-small'>
              {elemento.status_conf}
            </div> */}
           {(elemento.status=='INFORMATION_REQUESTED')?<div className='field-body-table-Buzon field-larger'>{'En espera de respuesta'}</div>: <div className='field-body-table-Buzon field-larger'>
            
              <div className='cont-img-field-acciones'>
                <img className='img-field-acciones' style={{width:'50%'}}src='/iconos/aceptar.png' title='Aceptar' name='Aceptar' ci_id={elemento.mail_id} onClick={(e) =>{e.stopPropagation(); handleActionResponse(elemento,'approve')}} />
              </div>
              <div className='cont-img-field-acciones'>
                <img className='img-field-acciones'style={{width:'50%'}} src='/iconos/interrogation.png' title='Requiere Info' name='Requiere Info' ci_id={elemento.mail_id} onClick={(e) =>{e.stopPropagation(); handleActionResponse(elemento,'request_info')}} />
              </div>
              <div className='cont-img-field-acciones' >
                <img className='img-field-acciones'style={{width:'50%'}} src='/iconos/rechazar.png' title='Rechazar'name='Rechazar' ci_id={elemento.mail_id} onClick={(e)=> {e.stopPropagation(); handleActionResponse(elemento,'reject')}} />
              </div>
            </div>}
          </div>
        ))
      }
      {
        (dataList.length==0)?<div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>:''
      }
    </div>
      <Modal
      isOpen={deleteBuzonModalOpen}
      // isOpen={true}
      // onAfterOpen={afterOpenExeption}
      onRequestClose={closDeleteBuzonModal}
      style={deleteBuzonModalStyles}
      contentLabel="Example Modal2"
      // shouldCloseOnOverlayClick={false}
      >
        <ModalDeleteBuzon buscar_Buzon={buscar_Buzon} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server}  auth={auth} setRegisterIsValid ={setRegisterIsValid } setData={setData} setLoading={setLoading} setError={setError} Buzon={userSelected} closDeleteBuzonModal={closDeleteBuzonModal}></ModalDeleteBuzon>
  </Modal>
  {/* modal Buzon que afecta */}
  
  </>
  )
}

export default BuzonList